import { deleteNotificationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteNotificationCallable = getCallable(
  deleteNotificationDefinition,
);
